export const sortOrder = [
  "MORNING",
  "BEFORE NOON",
  "MIDDAY",
  "AFTERNOON",
  "EVENING",
  "NIGHT",
];
